import ExportModal from './link-export-modal'

class Export {
    Vue;
    _instance;

    storage = {}

    constructor(Vue) {
        this.Vue = Vue
    }

    get instance() {
        if (!this._instance) {
            this._instance = this.newInstance()
        }
        return this._instance
    }

    newInstance() {
        const instance = new this.Vue(ExportModal).$mount()
        document.body.appendChild(instance.$el)
        return instance
    }

    show(data) {
        return new Promise((rs) => {
            this.instance.data = data;
            this.Vue.prototype.$nextTick(() => {
                this.instance.onConfirm = rs
                this.instance.show = true;
            })
        })
    }

    onConfirm(obj) {

    }

}

export default Export
